<template>
<div class="main-content-wrapper">
	<div class="view-area">
		<Index v-if="isIndexView"></Index>
	</div>
	<div class="view-area">
		<Session v-if="isSessionView"></Session>
	</div>
	<div class="view-area">
		<Transport v-if="isTransportView"></Transport>
	</div>
	<router-view></router-view>
</div>
</template>

<script>

import Index from "./Index";
import Session from "./Session";
import Transport from "./Transport";

export default {
  name: "Container",
  components: {
  	Index
  },
  data() {
	  return {
		  isIndexView: false,
		  isSessionView: false,
		  isTransportView: false
	  };
  }
}

</script>

<style scoped>

/** Color.css */

.color-A {
	/* fallback */
	/*background-color: #2C2C2C;*/
    background-color: #3D7A99;
	height:40px;
}

.color-B {
	/* fallback */
	background-color: #666;
	height:40px;
}

.color-C {
	color: #DDD;
	background-color: #DDD;
}

.color-D {
	/* fallback */
	background-color: #FFFFFF;

	/* Safari 4-5, Chrome 1-9 */
	background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(rgba(202, 202, 202, 0.8)), to(#FFFFFF));

	/* Safari 5.1, Chrome 10+ */
	background: -webkit-linear-gradient(top, #FFFFFF, rgba(202, 202, 202, 0.8));

	/* Firefox 3.6+ */
	background: -moz-linear-gradient(top, #FFFFFF, rgba(202, 202, 202, 0.8));

	/* IE 10 */
	background: -ms-linear-gradient(top, #FFFFFF, rgba(202, 202, 202, 0.8));

	/* Opera 11.10+ */
	background: -o-linear-gradient(top, #FFFFFF, rgba(202, 202, 202, 0.8));
}

.color-E {
	/* fallback */
	background-color: #000;
}

.color-F {
	/* fallback */
	background-color: #E58C26;

	/* Safari 4-5, Chrome 1-9 */
	background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#F67C21), to(#FABE41));

	/* Safari 5.1, Chrome 10+ */
	background: -webkit-linear-gradient(top, #FABE41, #F67C21);

	/* Firefox 3.6+ */
	background: -moz-linear-gradient(top, #FABE41, #F67C21);

	/* IE 10 */
	background: -ms-linear-gradient(top, #FABE41, #F67C21);

	/* Opera 11.10+ */
	background: -o-linear-gradient(top, #FABE41, #F67C21);
	height:40px;
	-webkit-border-radius: 20px;
    border-radius: 20px;
}

/** Font.css */
.font-A {
	/*font-family: "Georgia Regular", Georgia;*/
    font-family: "Arial", sans-serif;
	font-size: 0.750em;
	text-align: right;
	color: #FFF;
}

.font-B {
	/*font-family: "Georgia Bold", Georgia;*/
    font-family: "Arial", sans-serif;
	font-size: 1.50em;
	text-align: right;
	color: #FFF;
}

.font-B2 {
    /*font-family: "Georgia Regular", Georgia;*/
    font-family: "Arial", sans-serif;
    font-size: 1.60em;
    text-align: center;
    color: #FFF;
}

.font-C {
	/*font-family: "Georgia Bold", Georgia;*/
    font-family: "Arial", sans-serif;
	font-size: 0.875em;
	text-align: right;
	color: #FFF;
}

.font-D {
	/*font-family: "Georgia Regular", Georgia;*/
    font-family: "Arial", sans-serif;
	font-size: 1.875em;
	text-align: center;
	color: #FFF;
}

.font-E {
	font-family: "Arial Narrow", Arial;
	font-size: 1.250em;
	text-align: center;
	color: #FFF;
}

.link-E {
    font-family: "Arial Narrow", Arial;
    text-align: center;
    color: #FFF;
}

.font-EE {
    font-family: "Arial Bold", Arial !important;
    font-size: 1.250em !important;
    text-align: center !important;
    color: #3D7A99 !important;
}

.font-F {
	font-family: "Georgia Narrow", Georgia;
	font-size: 0.938em;
	text-align: center;
	color: #666;
}

.font-G {
	font-family: "Georgia Narrow", Georgia;
	font-size: 1.125em;
	text-align: center;
	color: #2C2C2C;
}

.font-H {
	font-family: "Georgia Narrow", Georgia;
	font-size: 1.125em;
	text-align: center;
	color: #2C2C2C;
}

.font-I {
	font-family: "Georgia Narrow", Georgia;
	font-size: 1.313em;
	text-align: center;
	color: #2C2C2C;
}

.font-J {
	font-family: "Georgia Narrow", Georgia;
	font-size: 1.313em;
	text-align: center;
	color: #2C2C2C;
}

.font-K {
	font-family: "Georgia Narrow", Georgia;
	font-size: 1.125em;
	color: #666;
}

.font-L {
	font-family: "Georgia Regular", Georgia;
	font-size: 0.875em;
	color: #333;
}

.font-M {
	font-family: "Georgia Narrow Regular", Georgia;
	font-size: 1.50em;
	text-align: center;
	color: #FFF;
}

.font-N {
	font-family: "Georgia Narrow Bold", Georgia;
	font-size: 1.250em;
	text-align: center;
	color: #FFF;
	text-shadow: 1px 1px 1px #000;
	filter: dropshadow(color=#000, offx=1, offy=1);
}

.font-N a {
	text-decoration: underline;
}

.font-O {
	font-family: "Georgia Regular", Georgia;
	line-height: 1.250em;
	font-size: 0.625em;
	text-align: center;
	color: #FFF;
}

.font-O a {
	text-decoration: underline;
	color: #FFF;
}

.font-B-container {
	/*font-family: "Georgia Bold", Georgia;*/
    font-family: "Arial", sans-serif;
	font-size: 1.125em;
	text-align: center;
	color: #000;
}

.font-C-container {
	font-family: "Georgia Regular", Georgia;
	font-size: 0.875em;
	text-align: center;
	color: #666;
}

.font-D-container {
	/*font-family: "Georgia Regular", Georgia;*/
    font-family: "Arial", sans-serif;
	font-size: 0.875em;
	text-align: center;
	color: #000;
}

.font-F-container {
	font-family: "Georgia Regular", Georgia;
	font-size: 0.750em;
	text-align: center;
	color: #0000CC;
}

.font-G-container {
	font-family: "Georgia Regular", Georgia;
	font-size: 0.750em;
	text-align: center;
	color: #666;
}

.font-H-container {
	font-family: "Georgia Regular", Georgia;
	font-size: 0.875em;
	text-align: center;
	color: #000;
}

.font-J-container {
	font-family: "Georgia Bold", Georgia;
	font-size: 1.125em;
	text-align: center;
	color: #000;
}

/** style.css */
html {
	height:100%;
}

body {
	color:#FFF;
	font-family:Georgia, "Times New Roman", Times, serif;
	font-size:100%;

	background-color: #CCCCCC;

	height:100%;
	/*background-image:url('../images/bg.jpg');*/
	/*background-position: center bottom;*/
    background-position: left center;
    background-size: cover;
	background-repeat: no-repeat;
}

body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, input, textarea, p, blockquote, th, td {
	padding:0px;
	margin:0px;
}

a {
	color: #00F;
}

p a{
    color: #fff;
}

.mobile {
	display:none;
}
.tablet {
	display:none;
}

.non-mobile {
	display:block;
}

.scaledown {
    width: 570px;
}

.card {
    height: 345px;
}


.link-button {
    font-size: 1em;
    display: inline-block;
    background:none!important;
    border:none;
    padding:0!important;
    cursor:pointer;
    text-decoration:underline;
}
.link-button:hover{
    text-decoration:underline;
}

.grayscale {
    filter: url("data:image/svg+xml;utf8,<svg><filter id=\'grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#grayscale"); /* Firefox 10+ */
    filter: gray; /* IE6-9 */
    -webkit-filter: grayscale(100%); /* Chrome 19+ & Safari 6+ */
    -webkit-transition: all .6s ease; /* Fade to color for Chrome and Safari */
    -webkit-backface-visibility: hidden; /* Fix for transition flickering */
}

#access_code_link{
    font-size: 1.5em;
}

.connect-button-wrapper{
    padding-top:20px;
    padding-left:25px;
    padding-right:25px;
}

#div-header {
	height:100px;
	width:100%;
	max-width:1400px;
	margin:0 auto;
}

#div-header img {
	float:left;
	padding:25px;
}

#div-address {
	float:right;
	padding:30px;
}

#div-footer {
	min-height:70px;
	width:100%;
	margin:0 auto;
}

#div-faded-background {
	top:0px;
	position:absolute;
	z-index:1020;
	background-color:#000000;
	zoom: 1;
	filter: alpha(opacity=70);
	opacity: 0.7;
	display:none;
	float:none;
}

#div-trouble-container {
	z-index:1030;
	position:absolute;
	width:100%;
	max-width:500px;
	padding:30px;
	display:none;
	background-color:#FFF;
}

#div-trouble-container a {
	color:#333333;
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.75em;
	text-decoration:underline;
	padding-right:30px;
}

#div-disclaimer-container {
	z-index:1030;
	position:absolute;
	height:100%;
	max-height:500px;
	width:100%;
	max-width:500px;
	display:none;
	background-color:#FFF;
}

#div-disclaimer-container a {
	color:#333333;
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.75em;
	text-decoration:underline;
	padding-right:30px;
}

#div-disclaimer-container iframe {
	height:100%;
	max-height:449px;
	width:100%;
	max-width:500px;
}

.div-standard-container {
	display:block;

	z-index:1000;
	width:80%;
	max-width:570px;
	/*min-width:300px;*/
    width: 570px;

	margin-left:auto;
	margin-right:auto;
	overflow:hidden;
	position:relative;
}

.div-standard-container > div {
	padding: 5px;
	float: none;
}

#div-highspeed-container {
	z-index:1000;
	width:80%;
	max-width:500px;
	display:block;
	background-color:#FFF;
	padding:20px;
	margin-left:auto;
	margin-right:auto;
	overflow:hidden;
}

#div-enhanced-paid-tier-container {
	z-index:1000;
	width:80%;
	max-width:500px;
	display:block;
	background-color:#FFF;
	padding:20px;
	margin-left:auto;
	margin-right:auto;
	overflow:hidden;
}

#div-error-container {
	z-index:1000;
	width:80%;
	max-width:500px;
	display:block;
	background-color:#FFF;
	padding:30px;
	border:1px solid #9D102D;
	margin-left:auto;
	margin-right:auto;
	overflow:hidden;
}

.error-message {
	border:1px solid #9D102D;
	padding:10px;
	width:auto;
}


.headline {
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.800em;
	font-weight:bold;
	color:#9D102D;
}

.error-body {
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.650em;
	color:#9D102D;
}

.subhead {
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.875em;
	font-weight:bold;
	color:#333333;
}

.body-copy {
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.75em;
	color:#333333;
}

.input-field {
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.875em;
	color:#333333;
	height:30px;
	border:1px solid #333333;
	padding-left:5px;
	padding-right:5px;
}

.input-field-label {
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.625em;
	font-weight:bold;
	color:#333333;
	padding-bottom:3px;
}

.form-spacer {
	height:12px;
}

.links {
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.75em;
	text-decoration:underline;
	font-weight:normal;
	color:#333333;
}

.button-0 {
	width:250px;
	min-width:250px;
	border-style: none;
}

.div-lightbox-container {
	z-index:1030;
	position:absolute;
	width:100%;
	max-width:500px;
	display:none;
	background-color:#FFF;
}

.div-lightbox-container a {
	color:#333333;
	font-family:Arial, Helvetica, sans-serif;
	font-size:0.75em;
	text-decoration:underline;
}

.login-package-card{
    display: inline-block;
}

.font-D-container ul{
    height: 120px;
}
.font-D-container ul li{
    vertical-align: middle;
}

.form-space-container > * {
	margin: 0px 12px;
}

</style>